import React, { useState, useEffect } from 'react';
import Checkbox from "../Checkbox";
import {getValueOfPermissions, handleChangePermission} from "./rolesUtil";

const ComponentPermissionItem = ({role, permission}) => {
    const [isActive, setIsActive] = useState(false);
    const getIsActive = () => {
        return role.permissions.length ? getValueOfPermissions(role.permissions, permission.targetName, 'hasAccess') : false;
    };
    const handleIsActive = (checked) => {
        setIsActive(!isActive);
        handleChangePermission(checked, role, permission.targetName, permission);
    };
    useEffect(() => {
        setIsActive(getIsActive());
    }, [role, permission]);
    return (
        <Checkbox handleChecked={handleIsActive} checked={isActive} />
    );
};

export default ComponentPermissionItem;
